import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useState } from "react";
import { Pie } from "react-chartjs-2";
import "./chartArea.scss";

export default function ChartArea(props: {
  questionTitle?: string;
  labels?: string[];
  data?: number[];
}) {
  const [colors] = useState(
    [...Array(props.data?.length)].map((e) => getRandomColor())
  );
  ChartJS.register(ArcElement, Tooltip, Legend);
  function getRandomColor() {
    var letters = "0123456789ABCDEF".split("");
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  const data = {
    labels: props.labels,
    datasets: [
      {
        data: props.data,
        borderWidth: 1,
        backgroundColor: colors,
      },
    ],
  };
  return (
    <div className="chart-container">
      <h3 style={{ margin: "0.5rem", alignSelf: "flex-start" }}>
        {props.questionTitle}
      </h3>
      <hr style={{ width: "100%" }} />
      <div style={{ maxWidth: "350px", width: "100%" }}>
        <Pie data={data} options={{ responsive: true }} />
      </div>
    </div>
  );
}
